import styled from 'styled-components'

const Card = styled.div`
  margin-top: 14px;
  padding: 10px 0;
  background-color: white;
  border-radius: 20px;
  box-shadow: 0px 2px 10px 2px rgba(110, 110, 110, 0.06);
`
const QueryTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0px;
  line-height: 140%;
  color: var(--color-text--black);
  white-space: normal;
  word-break: break-word;
  flex: 1;
  min-width: 0;
  margin-right: 12px;
`
const QueryContent = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
border-bottom: 1px solid rgba(226, 232, 240, 1);
padding: 12px 0;
cursor: pointer;
margin: 0px 15px;
  &:last-child {
    border-bottom: none;
  }
`
const QueryCount = styled(QueryTitle)`
  color: var(--color-text-secondary);
  flex: 0 0 auto;
  overflow: visible;
  min-width: auto;
  margin-left: auto;
  margin-right: 0;
`
const ViewAllButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  color: var(--color-button-primary);
  padding: 12px 0;
  border-top: 1px solid rgba(226, 232, 240, 1);
`
export { Card, QueryTitle, QueryContent, QueryCount, ViewAllButton }
